export enum MenuActions {
    SAVE,
    ADD,
    DELETE,
    VIEW,
    WAIT,
    EDIT,
    REFRESH
  }
  